import { create } from "zustand";
import { projects } from "../data/projects";
import { wrapCarouselIndex } from "../lib/projectsCarousel";

export type CarouselDirection = -1 | 0 | 1;

type ProjectsCarouselState = {
  activeIndex: number;
  isDragging: boolean;
  isAnimating: boolean;
  direction: CarouselDirection;
  rotationProgress: number;
  setActiveIndex: (index: number) => void;
  setDragging: (value: boolean) => void;
  setAnimating: (value: boolean) => void;
  setDirection: (direction: CarouselDirection) => void;
  setRotationProgress: (value: number) => void;
};

const totalProjects = projects.length;

export const useProjectsCarouselStore = create<ProjectsCarouselState>((set) => ({
  activeIndex: 0,
  isDragging: false,
  isAnimating: false,
  direction: 0,
  rotationProgress: 0,
  setActiveIndex: (index) => {
    const nextIndex = wrapCarouselIndex(index, totalProjects);
    set({
      activeIndex: nextIndex,
      rotationProgress: index
    });
  },
  setDragging: (isDragging) => set({ isDragging }),
  setAnimating: (isAnimating) => set({ isAnimating }),
  setDirection: (direction) => set({ direction }),
  setRotationProgress: (rotationProgress) =>
    set({
      rotationProgress
    })
}));
